import { gql } from '@yi/core';

import { nr } from '~/src/common/newRelic';

export const identifyUser = (currentUser: gql.typesClient.Query_CurrentUser['CurrentUser']) => {
  nr.setAttribute('userId', currentUser?.id || '');
};
